import { createAPIModule } from 'utility/redux/apiModuleHelpers';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { createSelector } from 'reselect';
import { List as ImmutableList } from 'immutable';

dayjs.extend(localizedFormat);

const getStateSlice = (state) => state.api.network.dns.domain.details;

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
} = createAPIModule({
	getStateSlice,
	actionType: 'NETWORK_DNS_DOMAIN_DETAILS',
	method: 'POST',
	url: '/network/dns/domain/details.json',
});

const expired = createSelector(defaultSelectors.getStateSlice, (slice) =>
	Boolean(slice.getIn(['data', 'is_expired'], 0)),
);

const selectors = {
	autorenew: createSelector(defaultSelectors.getStateSlice, (slice) =>
		Boolean(slice.getIn(['data', 'autorenew'], false)),
	),
	autorenew_value: createSelector(defaultSelectors.getStateSlice, (slice) =>
		slice.getIn(['data', 'autorenew_value'], 'Off'),
	),
	registeredNameServers: createSelector(
		defaultSelectors.getStateSlice,
		(slice) => slice.getIn(['data', 'nameservers'], ImmutableList()),
	),
	expirationText: createSelector(
		defaultSelectors.getStateSlice,
		expired,
		(slice, isExpired) => {
			const verb = `Expire${isExpired ? 'd' : 's'}`;
			const date = slice.getIn(['data', 'expiration']);
			return verb && date ? `${verb} ${dayjs(date).format('l')}` : '';
		},
	),
	expired,
	domain: createSelector(defaultSelectors.getStateSlice, (slice) =>
		slice.getIn(['data', 'domain'], null),
	),
	isRGP: createSelector(defaultSelectors.getStateSlice, (slice) =>
		slice.getIn(['data', 'is_rgp']),
	),
	isRenewable: createSelector(defaultSelectors.getStateSlice, (slice) =>
		Boolean(slice.getIn(['data', 'is_renewable'])),
	),
	isSubdomain: createSelector(defaultSelectors.getError, (error) =>
		error
			? error
					.getIn(['data', 'error'])
					.includes('Subdomains cannot be registered')
			: false,
	),
	isTransfer: createSelector(defaultSelectors.getStateSlice, (slice) =>
		slice.getIn(['data', 'is_transfer'], 0),
	),
	renewalPrice: createSelector(defaultSelectors.getStateSlice, (slice) =>
		slice.getIn(['data', 'renewal_price']),
	),
	redemptionPrice: createSelector(defaultSelectors.getStateSlice, (slice) =>
		slice.getIn(['data', 'redemption_price']),
	),
	renewalMaxYears: createSelector(defaultSelectors.getStateSlice, (slice) =>
		parseInt(slice.getIn(['data', 'renewal_max_years'], 1), 10),
	),
	uniqId: createSelector(defaultSelectors.getStateSlice, (slice) =>
		slice.getIn(['data', 'uniq_id'], null),
	),
	purchasedPrivacy: createSelector(defaultSelectors.getStateSlice, (slice) =>
		Boolean(slice.getIn(['data', 'has_privacy'], 0)),
	),
	whoisPrivacy: createSelector(defaultSelectors.getStateSlice, (slice) =>
		slice.getIn(['data', 'privacy'], 'Off'),
	),
	...defaultSelectors,
};

export { actions, reducer, sagas, selectors };
